// 같은 자세의 본 행렬은 정점마다 곱하지 않고 한 번만 계산한다.
import * as THREE from 'three/webgpu';

/** update 후 다음 자세까지 사용할 CPU 스킨 정점 판독기. 원본 지오메트리와 본은 수정하지 않는다. */
export class PoseVertexReader {
  private readonly matrices: THREE.Matrix4[];
  private readonly base = new THREE.Vector4();
  private readonly transformed = new THREE.Vector4();
  constructor(private readonly mesh: THREE.SkinnedMesh, private readonly morph = true) {
    this.matrices = mesh.skeleton.bones.map(() => new THREE.Matrix4());
  }
  update(): void {
    const { bones, boneInverses } = this.mesh.skeleton;
    for (let i = 0; i < bones.length; i++) this.matrices[i].multiplyMatrices(bones[i].matrixWorld, boneInverses[i]);
  }
  local(index: number, target: THREE.Vector3): THREE.Vector3 {
    const mesh = this.mesh;
    // 액터 굽기는 기존처럼 원시 정점을, 카엘 분석은 morph를 포함한 정점을 사용한다.
    if (this.morph) THREE.Mesh.prototype.getVertexPosition.call(mesh, index, target);
    else target.fromBufferAttribute(mesh.geometry.getAttribute('position'), index);
    this.base.set(target.x, target.y, target.z, 1).applyMatrix4(mesh.bindMatrix);
    target.set(0, 0, 0);
    const indices = mesh.geometry.getAttribute('skinIndex'), weights = mesh.geometry.getAttribute('skinWeight');
    for (let k = 0; k < 4; k++) {
      const weight = weights.getComponent(index, k);
      if (weight !== 0) {
        this.transformed.copy(this.base).applyMatrix4(this.matrices[indices.getComponent(index, k)]);
        target.x += this.transformed.x * weight;
        target.y += this.transformed.y * weight;
        target.z += this.transformed.z * weight;
      }
    }
    return target.applyMatrix4(mesh.bindMatrixInverse);
  }
  world(index: number, target: THREE.Vector3, world = this.mesh.matrixWorld): THREE.Vector3 {
    return this.local(index, target).applyMatrix4(world);
  }
}
